module.exports = __webpack_public_path__ + "img/classe5.3f2948a8.jpg";